import { HMDOnlineStatusNotifications } from "@/components/HMDOnlineStatusNotifications";
import { Onboarding } from "@/components/Onboarding";
import { RateSessionDialog } from "@/components/RateSessionDialog";
import { SessionErrorHandler } from "@/components/SessionErrorHandler";
import { SessionIsReadyDialog } from "@/components/SessionIsReadyDialog";
import { SessionNotifications } from "@/components/SessionNotifications";
import { StreamingServerReadyNotification } from "@/components/StreamingServerReadyNotification";
import { UserPreferencesDialog } from "@/components/UserPreferencesDialog";
import { VirtualMachineIntentErrorHandler } from "@/virtual-machines/VirtualMachineIntentErrorHandler";
import { VmUpgradeNotification } from "@/virtual-machines/VmUpgradeNotification";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RequireAuth } from "../../components/RequireAuth";

export const Route = createFileRoute("/_authenticated")({
  component: () => (
    <RequireAuth>
      <Outlet />
      <RateSessionDialog />
      <SessionIsReadyDialog />
      <SessionErrorHandler />
      <HMDOnlineStatusNotifications />
      <SessionNotifications />
      <StreamingServerReadyNotification />
      <VirtualMachineIntentErrorHandler />
      <VmUpgradeNotification />
      <UserPreferencesDialog />
      <Onboarding />
    </RequireAuth>
  ),
});
